import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { ExportOrderKey } from "../../models/domains/pbm/exports/export-order-key";
import { TransactionalManagementIndicators } from "../../models/domains/pbm/transactional-management/transactional-management-indicators";
import { TransactionalManagementRequest } from "../../models/domains/pbm/transactional-management/transactional-management.request";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { IndicatorsParser } from "../parsers/pbm/transaction-management/indicators.parser";

import { PaginationTransactionalManagementModel, TransactionalManagementModel } from "../../models/domains/pbm/transactional-management/transactional-management.model";

@Injectable()
export class TransactionManagementRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private indicatorsParser: IndicatorsParser,
  ) {}

  public async searchSales(request: TransactionalManagementRequest): Promise<PaginationTransactionalManagementModel> {
    const body = {
      FiscalNumber: request.getFiscalNumber() ? { Value: request.getFiscalNumber().getValue() } : null,
      SocialNumber: request.geteSocialNumber() ? { Value: request.geteSocialNumber().getValue() } : null,
      Card: request.getCard() ? { CardNumber: request.getCard().getCardNumber() } : null,
      UniqueSequentialNumber: request.getUniqueSequentialNumber() ? { Value: request.getUniqueSequentialNumber() } : null,
      ShippingType: request.getShippingType() > -1 ? request.getShippingType() : null,
      StartAt: request.getStartDate(),
      EndAt: request.getEndDate(),
      SalesOrderMonitorStatus: request.getMonitorStatus(),
      StartIndex: request.getStartIndex(),
      TotalPerPages: request.getTotalPerPage(),
    };
    const headers = { "Content-Type": "application/json" };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data : any = await remoteGateway.postWithHeaders(new BackendUrl("/api/sales-order/monitor"), body, headers);
      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async searchSalesById(id : string): Promise<TransactionalManagementModel> {
    const headers = { "Content-Type": "application/json" };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data : any = await remoteGateway.getWithHeaders(new BackendUrl("/api/sales-order/monitor/" + id), headers);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async searchIndicators(request: TransactionalManagementRequest): Promise<TransactionalManagementIndicators> {
    const body = {
      FiscalNumber: request.getFiscalNumber() ? { Value: request.getFiscalNumber().getValue() } : null,
      SocialNumber: request.geteSocialNumber() ? { Value: request.geteSocialNumber().getValue() } : null,
      Card: request.getCard() ? { CardNumber: request.getCard().getCardNumber(), IsBlocked: true, IsCancelled: true } : null,
      UniqueSequentialNumber: request.getUniqueSequentialNumber() ? { Value: request.getUniqueSequentialNumber() } : null,
      ShippingType: request.getShippingType() > -1 ? request.getShippingType() : null,
      StartAt: request.getStartDate(),
      EndAt: request.getEndDate(),
      SalesOrderMonitorStatus: request.getMonitorStatus(),
      StartIndex: request.getStartIndex(),
      TotalPerPages: request.getTotalPerPage(),
    };
    const headers = { "Content-Type": "application/json" };
    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.postWithHeaders(new BackendUrl("/api/sales-order/indicator"), body, headers);
      return Promise.resolve(this.indicatorsParser.parse(data));
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async findNetworkTermExportOrderKey(request: TransactionalManagementRequest): Promise<ExportOrderKey> {
    const body = {
      FiscalNumber: request.getFiscalNumber() ? { Value: request.getFiscalNumber().getValue() } : null,
      SocialNumber: request.geteSocialNumber() ? { Value: request.geteSocialNumber().getValue() } : null,
      Card: request.getCard() ? { CardNumber: request.getCard().getCardNumber(), IsBlocked: true, IsCancelled: true } : null,
      UniqueSequentialNumber: request.getUniqueSequentialNumber() ? { Value: request.getUniqueSequentialNumber() } : null,
      ShippingType: request.getShippingType() > -1 ? request.getShippingType() : null,
      StartAt: request.getStartDate(),
      EndAt: request.getEndDate(),
      SalesOrderMonitorStatus: request.getMonitorStatus(),
      StartIndex: request.getStartIndex(),
      TotalPerPages: request.getTotalPerPage(),
    };
    const headers = { "Content-Type": "application/json" };
    try {
      const data = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .postWithHeaders(new BackendUrl("/api/sales-order/monitor/export"), body, headers);
      const exportOrderKey = new ExportOrderKey(data.toString());
      return exportOrderKey;
    } catch (referenceError) {
      const errorMessage = referenceError.error.Data.ErrorMessage;
      return await Promise.reject(errorMessage);
    }
  }
  public async findSalesDatails(id: string ): Promise<TransactionalManagementModel> {
  
    const headers = { "Content-Type": "application/json" };
    try {
      const data = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .getWithHeaders(new BackendUrl("/api/sales-order/monitor/" + id), headers);
     return Promise.resolve(data);
    } catch (referenceError) {
      const errorMessage = referenceError.error.Data.ErrorMessage;
      return await Promise.reject(errorMessage);
    }
  }

  public async cancelOrder(nsu : string, description): Promise<any> {
    const headers = { "Content-Type": "application/json" };
    try {
      const body = {
        NSU: nsu,
        Description: description,
      };
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data : any = await remoteGateway.postWithHeaders(new BackendUrl("/api/sales-order/cancel"), body, headers);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
